import { useMemo } from 'react';
import { AllowSkipCheckIn } from 'api/models/Users';
import { LOCATION_SETTING_OPERATOR_ROLES, useLocationSetting } from './useLocationSetting';

export const useAllowSkipCheckInSetting = () => {
  const {
    value: allowSkipCheckInSetting,
    setValue: setAllowSkipCheckInSetting,
    isLoading,
    canUpdate,
  } = useLocationSetting<AllowSkipCheckIn>('allow_skip_check_in', AllowSkipCheckIn.No, {
    roles: LOCATION_SETTING_OPERATOR_ROLES,
  });

  return useMemo(
    () => ({
      allowSkipCheckInSetting,
      allowSkipSetCheckIn:
        allowSkipCheckInSetting == AllowSkipCheckIn.Sets || allowSkipCheckInSetting == AllowSkipCheckIn.All,
      allowSkipImplantCheckIn:
        allowSkipCheckInSetting == AllowSkipCheckIn.Implants || allowSkipCheckInSetting == AllowSkipCheckIn.All,
      setAllowSkipCheckInSetting,
      isLoading,
      canUpdate,
    }),
    [allowSkipCheckInSetting, setAllowSkipCheckInSetting, isLoading, canUpdate],
  );
};
